import { render, staticRenderFns } from "./FloorSetting.vue?vue&type=template&id=d83c1260"
import script from "./FloorSetting.vue?vue&type=script&lang=js"
export * from "./FloorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports